<template>
  <div>
    <div class="title">修改门店信息（门店名称、收货地址、收货人、收货时间）？</div>
    <div class="content-info">
      <p class="txt1">登录状态下， APP端进入商城“我的”界面，点击门店图标，进入“变更门店信息”界面进行修改。</p>
      <ul class="p-left-6">
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/9f4a0d4778310fdc5d93c388a500e8db.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/9931819c4b298deb09e42c0a5434a428.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/3b7198684200c55e21ad4140664844d9.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
